<template>
  <div class="page-statistics-timing">
    <crm-panel :title="'打卡统计'">
      <div class="page-buttons">
        <crm-button
          v-if="webStatisticsAuth.crmclockin.export.auth"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <el-date-picker
              :clearable="false"
              :editable="false"
              v-model="searchForm.time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              align="right"
              start-placeholder="打卡日期始"
              end-placeholder="打卡日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-cascader
              clearable
              :options="timingRecordTeamList"
              :props="{ checkStrictly: true }"
              placeholder="团队"
              @change="changeParentTeam"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              class="input-with-select"
            >
              <el-select v-model="searchNameType" slot="prepend">
                <we-search-input-type-options />
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 打卡列表 -->
      <el-table
        :data="timingRecordList.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column prop="loginId" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="userName" align="center" label="用户">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="140"
          prop="tameName"
          align="center"
          label="团队"
        >
        </el-table-column>
        <el-table-column prop="attendanceDays" align="center" label="出勤天数">
        </el-table-column>
        <el-table-column prop="theNumberOfLate" align="center" label="迟到次数">
        </el-table-column>
        <el-table-column prop="leaveEarlyTimes" align="center" label="早退次数">
        </el-table-column>
        <el-table-column
          prop="goToWorkLackOfCardNumber"
          align="center"
          label="上班缺卡次数"
        >
        </el-table-column>
        <el-table-column
          prop="afterWorkLackOfCardNumber"
          align="center"
          label="下班缺卡次数"
        >
        </el-table-column>
        <el-table-column prop="absenteeismDays" align="center" label="旷工天数">
        </el-table-column>
        <el-table-column
          v-if="webStatisticsAuth.crmclockin.view.auth"
          prop="absenteeismDays"
          align="center"
          label="详情"
        >
          <template slot-scope="scope">
            <span @click="handleDetailShow(scope.row)" class="link">详情</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 签到列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="searchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="timingRecordList.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 详情弹窗 -->
    <div v-if="detail.visible">
      <el-dialog
        :title="
          `${detail.userName} ${detail.time[0]}~${detail.time[1]} 打卡详情`
        "
        :visible.sync="detail.visible"
        width="60%"
        @close="detail.visible = false"
      >
        <div class="mt20">
          <el-table :data="timingRecordDetail" border style="width: 100%">
            <el-table-column prop="checkType" label="考勤类型" align="center">
            </el-table-column>
            <el-table-column
              prop="locationResult"
              align="center"
              label="打卡位置"
            >
            </el-table-column>
            <el-table-column
              prop="baseCheckTime"
              width="180px"
              align="center"
              label="规定打卡时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.baseCheckTime | formatTimeFull }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="userCheckTime"
              width="180px"
              align="center"
              label="实际打卡时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.userCheckTime | formatTimeFull }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sourceType" align="center" label="打卡来源">
            </el-table-column>
            <el-table-column prop="timeResult" align="center" label="打卡结果">
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as utils from '@/scripts/utils';
import config from '~config';
import WeSearchInputTypeOptions from '~component/business/datastatistics/search-input-type-options';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';

export default {
  components: {
    WeSearchInputTypeOptions,
    crmPanel,
    crmButton,
  },
  filters: {
    formatTimeFull: utils.formatTimeFull,
  },
  data() {
    return {
      loading: false,
      searchName: null,
      searchNameType: 1,
      searchForm: {
        time: [],
        teamId: null,
        startDateStr: null,
        endDateStr: null,
        loginId: null,
        userName: null,
        pageNumber: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      isExportDisabled: false,
      // 详情
      detail: {
        userName: null,
        visible: false,
        time: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      timingRecordList: 'statistics/timingRecordList',
      webStatisticsAuth: 'authority/webStatisticsAuth',
      signInDetail: 'statistics/signInDetail',
      timingRecordTeams: 'statistics/timingRecordTeams',
      timingRecordDetail: 'statistics/timingRecordDetail',
    }),
    timingRecordTeamList() {
      let teamArr = [];
      teamArr = JSON.parse(JSON.stringify([this.timingRecordTeams]));
      this.deleteEmptyChild(teamArr);
      return teamArr;
    },
  },
  watch: {
    'searchForm.teamId': {
      handler: 'handleSearch',
    },
    'searchForm.time': {
      handler: 'handleSearch',
    },
  },
  created() {
    const startTime = new Date();
    const endTime = new Date();
    startTime.setDate(1);
    this.searchForm.time = [
      utils.formatTimeShow(startTime),
      utils.formatTimeShow(endTime),
    ];
    this.getTimingRecordTeams();
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      getTimingRecordList: 'statistics/getTimingRecordList',
      handleSignInExport: 'statistics/handleSignInExport',
      getSignInDetail: 'statistics/getSignInDetail',
      getTimingRecordTeams: 'statistics/getTimingRecordTeams',
      getTimingDetail: 'statistics/getTimingDetail',
    }),
    deleteEmptyChild(arr) {
      arr.forEach((item) => {
        if (!item.children || item.children.length <= 0) {
          delete item.children;
        } else {
          this.deleteEmptyChild(item.children);
        }
      });
    },
    changeParentTeam(team) {
      this.searchForm.teamId = team[team.length - 1];
    },
    handleSearch() {
      this.detail.time = this.searchForm.time;
      this.searchForm.pageNumber = 1;
      this.getTimingRecordData();
    },
    getTimingRecordData() {
      this.loading = true;
      this.searchForm.loginId = null;
      this.searchForm.userName = null;
      if (this.searchNameType === 1) {
        this.searchForm.loginId = this.searchName;
      } else if (this.searchNameType === 2) {
        this.searchForm.userName = this.searchName;
      }
      const { time, ...otherParams } = this.searchForm;
      this.getTimingRecordList({
        ...otherParams,
        startDateStr: this.searchForm.time[0],
        endDateStr: this.searchForm.time[1],
      }).finally(() => {
        this.loading = false;
      });
    },
    // 导出
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });
      this.searchForm.loginId = null;
      this.searchForm.userName = null;
      if (this.searchNameType === 1) {
        this.searchForm.loginId = this.searchName;
      } else if (this.searchNameType === 2) {
        this.searchForm.userName = this.searchName;
      }
      const { time, ...otherParams } = this.searchForm;
      const params = {
        ...otherParams,
        startDateStr: this.searchForm.time[0],
        endDateStr: this.searchForm.time[1],
      };

      let url = `${config.api || ''}/api/clockIn/download?`;
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      utils.downloadByUrl(url);
      this.isExportDisabled = false;
      if (this.notify) this.notify.close();
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.searchForm.pageNumber = 1;

      this.getTimingRecordData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.searchForm.pageNumber = val;
      this.getTimingRecordData();
    },
    handleDetailShow(row) {
      this.detail.userName = row.userName;
      this.getTimingDetail({
        dingDingUserId: row.dingDingUserId,
        startDateStr: this.detail.time[0],
        endDateStr: this.detail.time[1],
      });
      this.detail.visible = true;
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/var.less';

.page-statistics-timing {
  display: flex;
  flex: 1;
  width: 100%;
  .el-dialog__body {
    border-top: 1px solid #cccccc;
    padding-top: 0;
    .dialog-date {
      font-size: 16px;
      line-height: 30px;
      border-bottom: 1px solid #cccccc;
    }
    .dialog-list-container {
      padding: 0;
      .dialog-list-item {
        padding: 10px 0;
        border-bottom: 1px solid #cccccc;
        .list-item-time {
          margin-right: 20px;
        }
      }
    }
  }
}
.el-tooltip__popper {
  width: 300px;
}
</style>
